import axios from "axios";
import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { URLS } from "../config";
import { components } from "../components";
import { course as elements } from "../course";
import properties from "../staticdata/properties";
import logo from "../assets/nestfin/Nestfin_logo.png";
// import logo from "../assets/nestfin/NexfinPng.png"
import { BlockHeading } from "../components/BlockHeading";
import { hooks } from "../hooks";
// import { PropertyCardList } from './PropertyCardList';

export const Shortlisted: React.FC = () => {
  const navigate = hooks.useNavigate();
  const location = useLocation();
  const { pathname, state } = location;

  const type = state?.type || "shortlisted";
  const title = state?.type;

  useEffect(() => {
    console.log(title, "this is coming form locaiton ");
  }, []);

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };

    scrollToTop();
  }, [pathname]);

  const renderImageBackground = (): JSX.Element => {
    return <components.Background version={1} />;
  };
  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        goBack={false}
        line={false}
        leftlogo={true}
        rightlogo={false}
        // search={true}
        filter={false}
        // logo={true}
        title={" "}
        centerImageSrc={logo}
      />
    );
  };

  // const renderContent = (): JSX.Element => {
  //     return (
  //         <PropertyCardList
  //             title="My Booking"
  //             properties={shortListedList}
  //             dateLabel="My Booking"
  //             dateField="shortListedDate"
  //             showBookNow
  //         />
  //     );
  // };

  const shortListedList = [
    {
      id: 1,
      title: "Zolo County PG/Paying Guest",
      price: "₹ 8000/Month",
      location: "New Delhi",
      area: "Near Connaught Place, Delhi",
      rating: "4.5",
      bookingDate: "06-06-2025",
      image:
        "https://plus.unsplash.com/premium_photo-1676823547752-1d24e8597047?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8bGl2aW5nJTIwcm9vbXxlbnwwfHwwfHx8MA%3D%3D",
    },
    {
      id: 2,
      title: "Vizima Abode Girls PG/Paying",
      price: "₹ 9500/Month",
      location: "Gurugram",
      area: "HSR Layout, Bangalore - Tech Hub",
      rating: "4.8",
      bookingDate: "06-06-2025",
      image:
        "https://img.freepik.com/premium-photo/kitchen_602868-178.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_hybrid&w=740",
    },
    {
      id: 3,
      title: "3 BHK Flat",
      price: "₹ 4500/Month",
      location: "Delhi",
      area: "Civil Line New Delhi",
      rating: "4.6",
      bookingDate: "06-06-2025",
      image:
        "https://img.freepik.com/free-photo/modern-apartment-architecture_1268-14696.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_hybrid&w=740",
    },
    {
      id: 4,
      title: "Green Stay Co-Living",
      price: "₹ 7200/Month",
      location: "Noida",
      area: "Sector 62, Noida",
      rating: "4.4",
      bookingDate: "06-06-2025",
      image:
        "https://img.freepik.com/premium-photo/large-bright-room-hostel-with-three-beds-white-bedding_173815-17049.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_hybrid&w=740",
    },
    {
      id: 5,
      title: "Elite PG for Women",
      price: "₹ 8800/Month",
      location: "Gurugram",
      area: "DLF Phase 2, Gurugram",
      rating: "4.7",
      bookingDate: "06-06-2025",
      image:
        "https://img.freepik.com/premium-photo/dream-home-ideas-floor-plans-cottage-designs-peaceful-outdoor-spaces-with-trees-landscapes_1195432-921.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_hybrid&w=740",
    },
    {
      id: 6,
      title: "Boys PG with Meals",
      price: "₹ 5600/Month",
      location: "Delhi",
      area: "Rohini Sector 11, Delhi",
      rating: "4.2",
      bookingDate: "06-06-2025",
      image:
        "https://img.freepik.com/premium-photo/dormitory-facilities-bedroom-professional-photography_925376-46605.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_hybrid&w=740",
    },
    {
      id: 7,
      title: "Studio Apartment in Noida",
      price: "₹ 9800/Month",
      location: "Noida",
      area: "Sector 18, Noida",
      rating: "4.6",
      bookingDate: "06-06-2025",
      image:
        "https://img.freepik.com/free-photo/house-isolated-field_1303-23772.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_hybrid&w=740",
    },
    {
      id: 8,
      title: "Cozy PG for Working Women",
      price: "₹ 7500/Month",
      location: "Delhi",
      area: "Lajpat Nagar, Delhi",
      rating: "4.5",
      bookingDate: "06-06-2025",
      image:
        "https://img.freepik.com/premium-photo/dream-home-ideas-floor-plans-cottage-designs-peaceful-outdoor-spaces-with-trees-landscapes_1195432-921.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_hybrid&w=740",
    },
    {
      id: 9,
      title: "Furnished 1 BHK Flat",
      price: "₹ 10500/Month",
      location: "Gurugram",
      area: "Sushant Lok, Gurugram",
      rating: "4.8",
      bookingDate: "06-06-2025",
      image:
        "https://img.freepik.com/premium-photo/cozy-modern-house-with-garage-cobblestone-driveway-modern-architecture_116317-5584.jpg?uid=P26384211&ga=GA1.1.1865081046.1748782222&semt=ais_hybrid&w=740",
    },
    {
      id: 10,
      title: "Affordable PG with Wi-Fi",
      price: "₹ 5000/Month",
      location: "Noida",
      area: "Sector 15, Noida",
      rating: "4.1",
      bookingDate: "06-06-2025",
      image:
        "https://teja12.kuikr.com/is/p/f/800x600/guide/wp-content/uploads/2020/10/PG-for-rent4.jpg",
    },
  ];

  const renderContent = (): JSX.Element => {
    return (
      <main style={{ paddingBottom: 30 }}>
        <BlockHeading
          title="Shortlisted Properties"
          // viewAllOnClick={() => {
          //     navigate('/category-list', { state: { title: 'Nearest For You' } });
          // }}
          containerStyle={{ marginTop: 15, padding: "0 20px" }}
        />
        <div style={{ paddingTop: 10, paddingBottom: 20 }}>
          {shortListedList.map((course, index) => {
            const isLast = index === shortListedList.length - 1;

            return (
              <div
                key={course.id}
                style={{
                  margin: "10px 10px 22px",
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                }}
              >
                {/* Course Card */}
                <div
                  style={{
                    width: "100%",
                    padding: "10px 13px 0px 10px",
                    cursor: "pointer",
                    userSelect: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: isLast ? 0 : 10,
                  }}
                  onClick={() => console.log("Go to course details")}
                >
                  {/* Image */}
                  <div
                    style={{
                      minWidth: 90,
                      minHeight: 90,
                      marginRight: 12,
                      position: "relative",
                    }}
                  >
                    <img
                      src={course.image}
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: 10,
                        position: "absolute",
                        inset: 0,
                      }}
                    />
                    <div
                      style={{
                        backgroundColor: "gold",
                        padding: "2px 6px",
                        borderRadius: 4,
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        fontSize: 12,
                      }}
                    >
                      ★ {course.rating}
                    </div>
                  </div>

                  {/* Text Content */}
                  <div style={{ width: "100%", position: "relative" }}>
                    <div style={{ display: "flex", marginLeft: 10 }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 7,
                        }}
                      >
                        <div
                          style={{
                            color: "#7065F0",
                            fontWeight: 700,
                            fontSize: 16,
                          }}
                        >
                          {course.price}
                        </div>

                        <div
                          style={{
                            fontWeight: 500,
                            fontSize: 16,
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {course.title}
                        </div>

                        <div style={{ fontSize: 14, color: "#000" }}>
                          {course.location}
                        </div>

                        <div style={{ fontSize: 13, color: "#555" }}>
                          {course.area}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Booking Info and Invoice Row */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 20px 15px",
                    fontSize: 13,
                    color: "#333",
                    borderBottom: isLast
                      ? "none"
                      : "1px solid rgba(0,0,0,0.05)",
                  }}
                >
                  <div>
                    <span style={{ fontWeight: 600 }}>Short Listed date:</span>
                    <strong> {course?.bookingDate}</strong>
                  </div>
                  <div>|</div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#7065F0",
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      navigate("/course-details", { state: { course } })
                    }
                  >
                    Book This Property
                    {/* <span style={{ fontSize: 18, marginLeft: 6 }}>📥</span> */}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </main>
    );
  };
  const renderBottomTabBar = (): JSX.Element => {
    return <components.BottomTabBar />;
  };
  return (
    <>
      {renderHeader()}
      {renderContent()}
      {renderBottomTabBar()}
    </>
  );
};

// CARD OLD
// const renderContent = (): JSX.Element => {
//     let data = [];
//     let title = '';
//     let dateLabel = '';
//     let dateField: 'bookingDate' | 'shortListedDate' | 'recentVisitDate';
//     if (type === 'bookings') {
//         data = shortListedList.slice(0, 2);
//         title = 'My Bookings';
//         dateLabel = 'Booking Date';
//         dateField = 'bookingDate';
//     } else if (type === 'visits') {
//         data = shortListedList.slice(2, 5);
//         title = 'Recent Visits';
//         dateLabel = 'Visited On';
//         dateField = 'recentVisitDate';
//     } else {
//         data = shortListedList;
//         title = 'Shortlisted Properties';
//         dateLabel = 'Shortlisted Date';
//         dateField = 'shortListedDate';
//     }

//     return (
//         <PropertyCardList
//             title={title}
//             properties={data}
//             dateLabel={dateLabel}
//             dateField={dateField}
//             showBookNow
//         />
//     );
// };

// my CARD HERE
// const renderContent = (): JSX.Element => {
//     return (
//         <main style={{ paddingBottom: 30 }}>
//             <BlockHeading
//                 title='My Booking '
//                 // viewAllOnClick={() => {
//                 //     navigate('/category-list', { state: { title: 'Nearest For You' } });
//                 // }}
//                 containerStyle={{ marginTop: 15, padding: '0 20px' }}
//             />
//             <div style={{ paddingTop: 10, paddingBottom: 20 }}>
//                 {courseList.map((course, index) => {
//                     const isLast = index === courseList.length - 1;

//                     return (
//                         <div key={course.id}
//                             style={{
//                                 margin: "10px 10px 22px",
//                                 borderRadius: "12px",
//                                 boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
//                             }}
//                         >
//                             {/* Course Card */}
//                             <div
//                                 style={{
//                                     width: '100%',
//                                     padding: "10px 13px 0px 10px",
//                                     cursor: 'pointer',
//                                     userSelect: 'none',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     marginBottom: isLast ? 0 : 10,
//                                 }}
//                                 onClick={() => console.log('Go to course details')}
//                             >
//                                 {/* Image */}
//                                 <div
//                                     style={{
//                                         minWidth: 90,
//                                         minHeight: 90,
//                                         marginRight: 12,
//                                         position: 'relative',
//                                     }}
//                                 >
//                                     <img
//                                         src={course.image}
//                                         style={{
//                                             width: '100%',
//                                             height: '100%',
//                                             borderRadius: 10,
//                                             position: 'absolute',
//                                             inset: 0,
//                                         }}
//                                     />
//                                     <div
//                                         style={{
//                                             backgroundColor: 'gold',
//                                             padding: '2px 6px',
//                                             borderRadius: 4,
//                                             position: 'absolute',
//                                             bottom: 0,
//                                             left: 0,
//                                             fontSize: 12,
//                                         }}
//                                     >
//                                         ★ {course.rating}
//                                     </div>
//                                 </div>

//                                 {/* Text Content */}
//                                 <div style={{ width: '100%', position: 'relative' }}>
//                                     <div style={{ display: 'flex', marginLeft: 10 }}>
//                                         <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
//                                             <div
//                                                 style={{
//                                                     color: '#7065F0',
//                                                     fontWeight: 700,
//                                                     fontSize: 16,
//                                                 }}
//                                             >
//                                                 {course.price}
//                                             </div>

//                                             <div
//                                                 style={{
//                                                     fontWeight: 500,
//                                                     fontSize: 16,
//                                                     overflow: 'hidden',
//                                                     whiteSpace: 'nowrap',
//                                                     textOverflow: 'ellipsis',
//                                                 }}
//                                             >
//                                                 {course.title}
//                                             </div>

//                                             <div style={{ fontSize: 14, color: '#000' }}>
//                                                 {course.location}
//                                             </div>

//                                             <div style={{ fontSize: 13, color: '#555' }}>
//                                                 {course.area}
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>

//                             </div>

//                             {/* Booking Info and Invoice Row */}
//                             <div
//                                 style={{
//                                     display: 'flex',
//                                     justifyContent: 'space-between',
//                                     alignItems: 'center',
//                                     padding: '10px 20px 15px',
//                                     fontSize: 13,
//                                     color: '#333',
//                                     borderBottom: isLast ? 'none' : '1px solid rgba(0,0,0,0.05)',
//                                 }}
//                             >
//                                 <div >
//                                     <span style={{ fontWeight: 600 }}>
//                                         Booking Date:
//                                     </span>
//                                     <strong> {course.bookingDate}</strong>
//                                 </div>
//                                 <div
//                                     style={{
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         color: '#7065F0',
//                                         fontWeight: 600,
//                                         cursor: 'pointer',
//                                     }}
//                                 >
//                                     <a href='https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf' target='_blank' style={{ textDecoration: "none", color: "#7065F0" }}>Download Invoice</a>
//                                     {/* <span style={{ fontSize: 18, marginLeft: 6 }}>📥</span> */}
//                                 </div>
//                             </div>
//                         </div>
//                     );
//                 })}
//             </div>
//         </main>
//     );
// };

// import axios from 'axios';
// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// import { URLS } from '../config';
// import { components } from '../components';
// import { course as elements } from '../course';
// import properties from '../staticdata/properties';

// export const ListDetails: React.FC = () => {
//     const location = useLocation();
//     const { pathname } = useLocation();

//     // const title = location.state.title;
//     const title = "vikas kumar";

//     const [loading, setLoading] = useState(false);
//     const [coursesData, setCoursesData] = useState<any>([]);

//     const getData = async () => {
//         setLoading(true);

//         try {
//             const results = await Promise.allSettled([axios.get(URLS.GET_COURSES)]);

//             const coursesResponse = properties;

//             if (coursesResponse.status === 'fulfilled') {
//                 setCoursesData(coursesResponse?.properties);
//             } else {
//                 // console.error('Error fetching courses:', coursesResponse.reason);
//             }
//         } catch (error) {
//             console.error('Unexpected error:', error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         getData();
//     }, []);

//     useEffect(() => {
//         const scrollToTop = () => {
//             window.scrollTo(0, 0);
//             document.documentElement.scrollTop = 0;
//         };

//         scrollToTop();
//     }, [pathname]);

//     const renderImageBackground = (): JSX.Element => {
//         return <components.Background version={1} />;
//     };

//     const renderHeader = (): JSX.Element => {
//         return (
//             <components.Header
//                 goBack={true}
//                 // filter={true}
//                 title={title}
//             />
//         );
//     };

//     const renderContent = (): JSX.Element => {
//         return (
//             <main style={{ paddingBottom: 0 }}>
//                 <div style={{ paddingTop: 10, paddingBottom: 20 }}>
//                     {coursesData.map((course: any, index: number, array: any) => {
//                         const isLast = index === array.length - 1;
//                         return (
//                             <elements.CourseCard
//                                 key={index}
//                                 course={course}
//                                 isLast={isLast}
//                                 section='category list'
//                             />
//                         );
//                     })}
//                 </div>
//             </main>
//         );
//     };

//     return (
//         <>

//             {renderHeader()}
//             {renderContent()}
//         </>
//     );
// };
